import { render } from "./task-card.vue?vue&type=template&id=04d70607"
import script from "./task-card.vue?vue&type=script&lang=js"
export * from "./task-card.vue?vue&type=script&lang=js"
script.render = render

export default script